import { SvgProps } from "../../types";

const ProtectionReport = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={17}
    fill="none"
    {...props}>
    <path
      fill={props.fill ? props.fill : "#666D87"}
      d="M2.318 2.125v4.519-.019 7.5-12Zm1.5 7.5h2.625a4.27 4.27 0 0 1 .975-1.5h-3.6v1.5Zm0 3H6.2a4.295 4.295 0 0 1-.112-1.5h-2.27v1.5Zm-1.5 3c-.412 0-.765-.147-1.059-.44a1.445 1.445 0 0 1-.44-1.06v-12c0-.413.146-.766.44-1.06.294-.293.647-.44 1.06-.44h6l4.5 4.5V7a4.332 4.332 0 0 0-.732-.234 6.158 6.158 0 0 0-.769-.122v-.769h-3.75v-3.75h-5.25v12h4.52c.2.3.424.578.674.834.25.257.525.479.825.666H2.318Z"
    />
    <path
      fill={props.fill ? props.fill : "#666D87"}
      stroke={props.fill ? props.fill : "#666D87"}
      strokeWidth={0.25}
      d="m10.755 13.597-.027.147H12.21l-.027-.147-.21-1.183a.867.867 0 0 0 .278-.286.909.909 0 0 0 .13-.478c0-.25-.09-.467-.267-.645a.883.883 0 0 0-.645-.268c-.25 0-.467.091-.644.268a.883.883 0 0 0-.268.645c0 .173.043.333.131.478a.867.867 0 0 0 .279.286l-.211 1.183Zm.683 2.9.03.007.03-.008c.944-.237 1.72-.779 2.33-1.618.61-.838.915-1.77.915-2.795V9.595l-.08-.03-3.15-1.182-.045-.016-.043.016-3.15 1.181-.082.03V12.084c0 1.024.306 1.957.915 2.795.61.84 1.387 1.38 2.33 1.618Zm1.62-2.319c-.423.617-.953 1.028-1.59 1.239-.636-.211-1.166-.622-1.59-1.239a3.615 3.615 0 0 1-.647-2.095V10.31l2.237-.839 2.238.84v1.773c0 .77-.216 1.466-.648 2.095Z"
    />
  </svg>
);
export default ProtectionReport;
